import React from "react";
import {Dropdown, Menu} from "antd";
import {NOOP} from "../../utils/NOOP.jsx";
import {EllipsisOutlined} from "@ant-design/icons";
import {DeliverySystem, pageSize} from "./consts.js";

export const columns = (currentPage, onEdit = NOOP) => [
    {
        title: "#",
        key: "#",
        width: 50,
        render(_, __, idx) {
            const realIndex = (currentPage - 1) * pageSize + idx + 1;
            return `${realIndex}`;
        }
    },
    {
        title: "מזהה ספק",
        key: "deliveryProviderId",
        render(_, {deliveryProviderId}) {
            return <div style={{width: "90px"}}>{deliveryProviderId}</div>;
        }
    },
    {
        title: "שם חברת השילוח",
        key: "name",
        render(_, {name}) {
            return name;
        }
    },
    {
        title: "איש קשר",
        key: "contactName",
        render(_, {contactName}) {
            return contactName;
        }
    },
    {
        title: "טלפון",
        key: "phone",
        render(_, {phone}) {
            return phone;
        }
    },
    {
        title: "מייל",
        key: "email",
        render(_, {email}) {
            return email;
        }
    },
    {
        title: "מערכת שילוחים",
        key: "deliverySystem",
        render(_, {deliverySystem}) {
            return deliverySystem ?? DeliverySystem.WellB;
        }
    },
    {
        render(_, deliveryProvider) {
            return (
                <div>
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={() => onEdit(deliveryProvider)}>עריכת ספק שילוח</Menu.Item>
                            </Menu>
                        }
                        trigger={["click"]}>
                        <EllipsisOutlined className="admin-orders-order-action-button" />
                    </Dropdown>
                </div>
            );
        }
    }
];
